module.exports = __webpack_public_path__ + "img/tehran-university.7848d521.png";